import { render, staticRenderFns } from "./PassoOutrasInfo.vue?vue&type=template&id=a4a61476&"
import script from "./PassoOutrasInfo.vue?vue&type=script&lang=js&"
export * from "./PassoOutrasInfo.vue?vue&type=script&lang=js&"
import style0 from "./PassoOutrasInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports